export enum HttpStatusCode {
    BadRequest = 400,
    ConflictError = 409,
    Forbidden = 403,
    InternalServerError = 500,
    NotFound = 404,
    Success = 200,
    Error = 201,
    ServiceUnavailable = 503,
    Unauthorized = 401,
    InValidAuthToken = 410,
    Found = 302,
    PasswordExpired = 206,
    NeedOtpConfirmation = 205,
    OTPExpired = 203,
    NeedSubScription = 211,
    VideoLinkExpired = 213,
    VideoLinkNotFound = 215,
    AppointmentSlotBooked = 208,
    ProviderNotAvailable = 209,
    DuplicateTemplateName = 207,
    DuplicateDiagnosis = 229,
    FormInUse = 225,
    QuestionInUse = 226,
    InvalidFeedbackLink = 219,
    FeedbackSubmitted = 220,
    InvalidProfileLink = 221,
    InvalidLink = 222,
    InvoicePaid = 223,
    DuplicateAllergy = 240,
    Duplicate = 244,
    DuplicateInsuranceCOBCode = 245,
}
